import { render, staticRenderFns } from "./SizeChartTable.vue?vue&type=template&id=d051eed8&scoped=true&"
import script from "./SizeChartTable.vue?vue&type=script&lang=js&"
export * from "./SizeChartTable.vue?vue&type=script&lang=js&"
import style0 from "./SizeChartTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SizeChartTable.vue?vue&type=style&index=1&id=d051eed8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d051eed8",
  null
  
)

export default component.exports